import { defineStore } from 'pinia'

export const useTranscoderPresetsStore = defineStore('useTranscoderPresetsStore', {
  state: () => {
    return {
      presets: []
    }
  }
})
